import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(2.000000, 2.000000)" fill="currentColor" fillRule="nonzero">
          <path d="M7.42230478,14.7079562 C7.60901145,14.9019853 7.85287323,15 8.09673501,15 C8.34059679,15 8.58445857,14.9019853 8.76735491,14.7079562 L16.3880355,6.70675601 C16.7595437,6.3166975 16.7595437,5.68260239 16.3880355,5.29254388 C16.0165274,4.90248537 15.4125884,4.90248537 15.0410802,5.29254388 L8.09482984,12.5856378 L4.95891977,9.29314397 C4.58741159,8.90308546 3.98347265,8.90308546 3.61196447,9.29314397 C3.24045629,9.68320248 3.24045629,10.3172976 3.61196447,10.7073561 L7.42230478,14.7079562 Z" />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
